import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getSummaryJR = createAsyncThunk(
    "getSummaryJR/get",
    async ({Year,Month, KlienID,url}, thunkAPI) => {
        let formData = new FormData();
        formData.append("KlienID", KlienID);
        formData.append("Month", String(Month.toString()));
        formData.append("Year", String(Year.toString()));

        try {
            const response = await axios.post(
                url,
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getSummaryV2 = createAsyncThunk(
    "getSummaryV2/get",
    async ({Year, Month, KlienID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("KlienID", KlienID || "");
        formData.append("Year", String(Year));
        formData.append("Month", String(Month));
        try {
            const u = JSON.parse(localStorage.getItem("user") || "{}");
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "getOperationalSummaryV2",
                formData,
                {headers: {Authorization: "Bearer " + u.Token, Accept: "*/*"}}
            );
            if (response.status === 200) return response.data;
            return thunkAPI.rejectWithValue(response.data);
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response?.data);
        }
    }
);

const initialState = {
    message: "",
    v2: null,
    isV2Loading: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    errorMessage: "",
};

export const operationalSummarySlice = createSlice({
    name: "operationalSummary",
    initialState,
    reducers: {},
    extraReducers: {
        [getSummaryJR.fulfilled]: (state, {payload}) => {

            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getSummaryJR.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getSummaryJR.pending]: (state) => {
            state.isGetFetching = true;
        },
        [getSummaryV2.pending]: (state) => {
            state.isV2Loading = true;
            state.errorMessage = "";
        },
        [getSummaryV2.fulfilled]: (state, {payload}) => {
            state.isV2Loading = false;
            state.v2 = (payload && payload.data) || {Data: [], GrandTotal: 0};
        },
        [getSummaryV2.rejected]: (state, {payload}) => {
            state.isV2Loading = false;
            state.v2 = {Data: [], GrandTotal: 0};
            state.errorMessage = (payload && payload.message) || "Gagal memuat summary";
        },
    },
});


export const operationalSummarySelector = (state) => state.operationalSummary;
